export const useManageReportModalStyles = () => {
    return {
      modal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '75vw',
        height: '75vh',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        outline: 'none',
        borderRadius: '1rem',
        padding: '1rem',
        paddingBottom: '3rem',
      },
      close: {
        float: 'right'
      },
    };
  };